const scrollIntoView = require('scroll-into-view');
import { bus } from '@/app';

export default {
    mounted() {
        const self = this;

        this.$nextTick().then(() => {

            const headerHeight = document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0].clientHeight : 0;
            const topOffset = headerHeight + 40;

            const scrollOptions = {
                align: {
                    top: 0,
                    topOffset: topOffset
                },
            }

            if (window.location.hash) {
                const element = document.getElementById(window.location.hash.substr(1))
                if (window.location.hash == "#afspraak-maken") {
                    bus.$emit('slideout', 'contact');
                } else if (element) {
                    scrollIntoView(element, scrollOptions);
                }
            }

            const scrollElements = document.querySelectorAll("a[href^='#']");

            scrollElements.forEach((element) => {
                if (element.getAttribute('href') !== '#') {
                    element.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (e.target.getAttribute('href') == "#afspraak-maken") {
                            bus.$emit('slideout', 'contact');
                        } else if (e.target.getAttribute('href') == null) {
                            let target = e.target.closest("a").getAttribute('href');
                            scrollIntoView(document.querySelector(target), scrollOptions, function () {
                                history.pushState({}, '', target);
                            });
                        } else {
                            let target = e.target.getAttribute('href');
                            scrollIntoView(document.querySelector(target), scrollOptions, function () {
                                history.pushState({}, '', target);
                            });
                        }
                    })
                }
            })
        });
    },
};
